/**
 * The smelting plant license, deliberately NOT modeled as a `Project` (see
 * domain/entities/Project.entity.ts) — per explicit client instruction, this
 * is a distinct "industrial license" fact, not a mine or exploration area,
 * and must never be visually grouped with them.
 *
 * Imported directly into ProjectsPage without a dedicated Use
 * Case/Repository layer — same precedent as `contactInfoContent` in
 * features/contact/components/ContactPage.tsx: a single static fact, not a
 * user-manageable list, so the full static-source/use-case machinery used
 * for actual content collections (minerals, services, ...) would be
 * over-engineering for one item. If this ever needs to be a real list of
 * multiple industrial licenses, promote it to a proper feature at that point.
 */
export interface IndustrialProjectInfo {
  title: string;
  type: string;
  location: string;
  description: string;
}

export const industrialProjectsContent: IndustrialProjectInfo[] = [
  {
    title: 'کارخانه ذوب سرب و روی',
    type: 'مجوز تأسیس صنعتی',
    location: 'شهرک صنعتی شماره ۱ زاهدان',
    description: 'شرکت دارای مجوز تأسیس کارخانه ذوب سرب و روی در شهرک صنعتی شماره ۱ زاهدان است.'
  }
];
